import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { HostListener, Component, inject } from '@angular/core';
import { ThemePalette, MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { NgStyle } from '@angular/common';

export interface BlockUserResult {
  blockReason: string;
}

@Component({
    selector: 'block-user-dialog',
    templateUrl: './block-user-dialog.component.html',
    styleUrl: './block-user-dialog.component.scss',
    imports: [MatDialogModule, FormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, NgStyle, MatInputModule, MatButtonModule]
})
export class BlockUserDialogComponent {
  dialogRef = inject<MatDialogRef<BlockUserDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  title: string;
  message: string;
  cancelButtonText: string;
  okButtonText: string;
  displayMessageAsHTML: boolean;
  okButtonColor: ThemePalette = 'primary';
  selectedBlockReason: string = "";
  otherBlockReason: string = "";

  blockReasons: string[] = [
    'Inactive customer',
    'Inactive user',
    'User no longer works at company',
    'User no longer needs access',
    'Incorrect email address',
    'Demo user',
    'Other'
  ];

  constructor() {
      this.title = this.data.title;
      this.message = this.data.message;
      this.cancelButtonText = this.data.cancelButtonText;
      this.okButtonText = this.data.okButtonText;
      this.displayMessageAsHTML = this.data.displayMessageAsHTML;
      this.okButtonColor = this.data.okButtonColor ? this.data.okButtonColor : 'primary';
    }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close();
  }

  onOkClick(): void {
    if(this.selectedBlockReason) {
      const blockReason: string = this.selectedBlockReason === 'Other' ? this.otherBlockReason : this.selectedBlockReason;
      const result: BlockUserResult = {
        blockReason: blockReason,
      };
      this.dialogRef.close(result);
    }
  }
}
